import styles from "../../../../AccountingPage.module.scss";
import { useEffect, useState } from "react";
import React from "react";
import { getEmployeeHistoryPayData, StatusChangeData } from "service/AccountingService";
import Notification from "utils/Notifications";
const EmployeeHystoryPayListContent = ({ render, setRender, id, dataemployee }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHistory = async (id) => {
    try {
      setLoading(true);
      const response = await getEmployeeHistoryPayData(id);
      setHistory(response.data);
    } catch (error) {
      setHistory([]);
      console.error("Ошибка при получении истории изменений сотрудника:", error);
    } finally {
      setLoading(false);
    }
  };
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const onStatusChange = async (id) => {
    let data = await StatusChangeData(id);
    setNotify({
      isOpen: true,
      message: "Статус успешно изменен!",
      type: "success",
      sound: "success"
    });
    setRender(true)
  };

  useEffect(() => {
    if (id) fetchHistory(id);
    setRender(false);
  }, [render, id]);

  return (
    <div className={styles.content_header} style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ width: "100%" }} className={styles.print_header_selection_shah}>
        <h3 className={styles.project__h}>Актуальные</h3>
        <hr style={{ borderTop: "2px solid #444", margin: "20px 0 0 0" }} />
        <table className={styles.table__wrapper}>
          <thead className={styles.table__head}>
            <tr className={styles.table__row}>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>ИНН</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>Фамилия</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>Имя</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>Подразделение</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>Должность</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>Ставка</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>Статус</span>
              </th>
              <th className={styles.table__item_person}>
                <span className={styles.table__title}>Дата и время</span>
              </th>
            </tr>
          </thead>
          <tbody className={styles.table__body}>
            <tr className={styles.table__row}>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee?.personaldata?.inn}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee?.personaldata?.surname}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee?.personaldata?.first_name}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee.department_name}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee.posititon_name}</span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>{dataemployee.stavka}</span>
              </td>
              <td className={styles.table__item_person}>
                <span
                  className={styles.table__title}
                  style={{
                    fontWeight: "700",
                    padding: "5px",
                    borderRadius: "6px",
                    display: "block",
                    textAlign: "center",
                    background:
                      dataemployee.status === "Работает"
                        ? "#5C5CFF"
                        : dataemployee.status === "Уволен(а)"
                          ? "#a00000ff"
                          : dataemployee.status === "В отпуске"
                            ? "#ec9900ff"
                            : dataemployee.status === "В командировке"
                              ? "#333333"
                              : dataemployee.status === "На больничном"
                                ? "#0a62a3"
                                : dataemployee.status === "В декретном отпуске"
                                  ? "#ffb6c1"
                                  : dataemployee.status === "В отпуске без содержания"
                                    ? "#999"
                                    : "transparent",
                    color: dataemployee.status ? "white" : "inherit",
                  }}
                >
                  {dataemployee.status || ""}
                </span>
              </td>
              <td className={styles.table__item_person}>
                <span className={styles.table__title}>
                  {new Date().toLocaleString("ru-RU", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <h3 className={styles.project__h}>История движения</h3>
        <hr style={{ borderTop: "2px solid #444", margin: "20px 0 0 0" }} />
      </div>
      <hr style={{ borderTop: "2px solid #444", margin: "20px 0" }} />
      {loading ? (
        <div>Загрузка...</div>
      ) : history.length === 0 ? (
        <div>Нет данных</div>
      ) : (
        // ...existing code...
        <table className={styles.table__wrapper}>
          <thead className={styles.table__head}>
            <tr className={styles.table__row}>
              <th className={styles.table__item_person}>№</th>
              <th className={styles.table__item_person}>Тип изменения</th>
              <th className={styles.table__item_person}>Описание</th>
              <th className={styles.table__item_person}>Новое значение</th>
              <th className={styles.table__item_person}>Период</th>
              <th className={styles.table__item_person}>Статус</th>
              
              <th className={styles.table__item_person}>Дата изменения</th>
              <th className={`${styles.table__item_person} ${styles.print_none_class}`}>Действия</th>
            </tr>
          </thead>
          <tbody className={styles.table__body}>
            {history.map((item, index) => (
              <tr className={styles.table__row} key={item.id}>
                <td className={styles.table__item_person}>{index + 1}</td>
                
                <td className={styles.table__item_person}>
                  {item.change_type_display}
                </td>
                <td className={styles.table__item_person}>
                  {item.description || "-"}
                </td>
                <td className={styles.table__item_person}>
                  {item.new_value || "-"}
                </td>
                <td className={styles.table__item_person}>
                  {item.date_from} — {item.date_to || "н/д"}
                </td>
                <td className={styles.table__item_person}>
                  <span
                    className={styles.table__title}
                    style={{
                      fontWeight: "700",
                      padding: "5px",
                      borderRadius: "6px",
                      display: "block",
                      textAlign: "center",
                      background:
                        item.status === "Действует"
                          ? "#5C5CFF"
                          : item.status === "Период действия истек"
                            ? "#a00000ff"
                            : item.status === "Отключено"
                              ? "#5e5e5eff"
                              : "transparent",
                      color: item.status ? "white" : "inherit",
                    }}
                  >
                    {item.status || "-"}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  {item.date}
                </td>
                <td className={`${styles.table__item_person} ${styles.print_none_class}`}>
                  {item.status === "Период действия истек" ? null : (
                    <button
                      className={styles.table__button}
                      style={{
                        fontWeight: "700",
                        padding: "5px",
                        borderRadius: "6px",
                        display: "block",
                        textAlign: "center",
                        background:
                          item.status === "Действует"
                            ? "#5e5e5eff"
                            : item.status === "Отключено"
                              ? "#5C5CFF"
                              : "transparent",
                        color: item.status ? "white" : "inherit",
                        border: "none",
                        cursor: "pointer",
                        minWidth: "90px"
                      }}
                      onClick={() => {
                        if (item.status === "Действует" || item.status === "Отключено") {
                          onStatusChange(item.id);
                        }
                      }}
                    >
                      {item.status === "Действует"
                        ? "Отключить"
                        : item.status === "Отключено"
                          ? "Включить"
                          : ""}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        // ...existing code...
      )}
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  );
};

export default EmployeeHystoryPayListContent;